import { DATE_FORMAT, EMPTY_VALUE_INDICATOR, useDateTimeService } from 'framework/utils';
import { CLIENT_PORTAL_USER_STATUSES } from 'domain/shared/clientPortal';
import { Tooltip } from 'framework/ui/mui-builder';
import { useShowContext } from 'framework/show';
import { ClientPortalUser } from '../types';
import { FieldProps, TextField } from 'framework/ui/field';

const ClientUserLoginDateField = ({ source = 'lastLoginAt', label }: FieldProps) => {
  const { data } = useShowContext<ClientPortalUser>();
  const { formatDateWithTimezone } = useDateTimeService();
  const user = data?.getData();
  const isInvited = user?.status === CLIENT_PORTAL_USER_STATUSES.INVITED;
  const date = isInvited ? user?.invitedAt : user?.lastLoginAt;
  const tooltipTitle = isInvited ? 'Invited at' : 'Last login at';
  const value = date ? (
    <Tooltip title={tooltipTitle} placement={'left'}>
      <div>{formatDateWithTimezone(date, DATE_FORMAT.FULL)?.trim()}</div>
    </Tooltip>
  ) : (
    EMPTY_VALUE_INDICATOR
  );

  return <TextField source={source} label={label} value={value} />;
};

export default ClientUserLoginDateField;
